import axios from "axios";

const API_BASE =
  process.env.REACT_APP_API_BASE && !process.env.REACT_APP_API_BASE.includes("192.168")
    ? process.env.REACT_APP_API_BASE
    : `${window.location.protocol}//${window.location.hostname}:8089`;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    Accept: "application/json",
    "ngrok-skip-browser-warning": "true",
  },
});

function redirectToLogin() {
  const currentPath = window.location.pathname;

  // Avoid infinite redirect if already on login page
  if (currentPath !== "/login") {
    window.location.href = "/login";
  }
}

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    config.headers = config.headers || {};
    config.headers.Accept = "application/json";
    config.headers["ngrok-skip-browser-warning"] = "true";

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      redirectToLogin();
    }

    return Promise.reject(error);
  }
);

export default api;